/* unplugin-vue-components disabled */import script from "./organ-user.vue?vue&type=script&setup=true&lang=ts"
export * from "./organ-user.vue?vue&type=script&setup=true&lang=ts"

import "./organ-user.vue?vue&type=style&index=0&id=013b59af&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-013b59af"]])

export default __exports__